import DgDictTree from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDictTree.install = function (Vue) {
  Vue.component(DgDictTree.name, DgDictTree)
}
export default DgDictTree

export { DgDictTree }
